import React, { useState, useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import { Trans } from "react-i18next";
import { Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Form, Table, Modal } from "react-bootstrap";
import axios from "axios";
import { environment } from "../../environment";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Select from "react-select";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Toggle from "react-toggle";
import "./PartnerScreens/Shipment.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const { SearchBar } = Search;

const ShipmentDetailsPage = ({ history, match, props }) => {
  const [show, setShow] = useState(false);
  const [showdevices, setShowDevices] = useState(false);
  const [DocketNo, setDocketNo] = useState("");
  const [createdbyLogisticManager, setcreatedbyManager] = useState(false);
  const [shipmentDetails, setShipmentDetails] = useState({});
  const [shipmentLogs, setShipmentLogs] = useState([]);
  const [devicedeials, setDeviceDetails] = useState([]);
  const [consignordetails, setConsignorDetails] = useState({});
  const [partnerdetails, setPartnerDetails] = useState({});
  const [partnerData, setPartnerData] = useState({});
  const [status, setStatus] = useState();
  const [isReturn, setIsReturn] = useState(false);
  const [toggleChecked, setToggleChecked] = useState(false);
  const [devices, setDevices] = useState([]);
  const [IsReceived, setIsReceived] = useState(false);
  const handleShow = () => setShow(true);

  const handleClose = () => {
    setShow(false);
  };
  const handleShowDevices = (key, val, e) => {
    console.log(val);
    setDevices(val);
    setShowDevices(true);
  };

  const handleCloseDevices = () => {
    setShowDevices(false);
  };
  // const submitHandler = (e) => {
  //   e.preventDefault();
  //   axios
  //     .put(
  //       environment.dap_url +
  //         "shipmentApi/updateShipmentStatus?_id=" +
  //         match.params.id,
  //       {
  //         status: status,
  //         statusBefore: shipmentDetails.status,
  //         notes: "abc",
  //       }
  //     )
  //     .then((res) => {
  //       MySwal.fire({
  //         title: <p>Status Changed Successfully</p>,
  //         type: "success",
  //       });
  //     })
  //     .catch((err) => {
  //       MySwal.fire({
  //         title: <p>Unable to change the status</p>,
  //         type: "error",
  //       });
  //     });
  // };
  // const ChangeStatus = (e) => {
  //   setStatus(e.value);
  //   // setStatus(status);
  // };
  console.log(consignordetails);
  useEffect(() => {
    let id = match.params.id;
    getShipmentData(id);
  }, []);
  const Approve = () => {
    let id = match.params.id;
    axios
      .get(
        environment.dap_url +
          "shipmentApi/approveRejectShipment?newStatus=3&shipmentId=" +
          id
      )
      .then((res) => {
        MySwal.fire({
          title: <p>Shipment Has been Approved</p>,
          type: "success",
        });

        getShipmentData(id);
      })
      .catch((err) => {
        MySwal.fire({
          title: <p>Unable To Approve the Shipment</p>,
          type: "success",
        });
      });
  };
  const Reject = () => {
    let id = match.params.id;
    axios
      .get(
        environment.dap_url +
          "shipmentApi/approveRejectShipment?newStatus=4&shipmentId=" +
          id
      )
      .then((res) => {
        MySwal.fire({
          title: <p>Shipment Has been Rejected</p>,
          type: "success",
        });
        getShipmentData(id);
      })
      .catch((err) => {
        MySwal.fire({
          title: <p>Unable To Approve the Shipment</p>,
          type: "success",
        });
      });
  };
  const toggle = (e) => {
    e.persist();
    console.log(e.target.value);
    console.log(match.params.id);
    const userId = JSON.parse(localStorage.getItem("user"))._id;
    axios
      .post(environment.dap_url + "shipmentApi/receiveBox", {
        shipmentIdMongo: match.params.id,
        boxId: e.target.value,
        tenantId: "13814000-1dd2-11b2-8080-808080808080",
        inventoryUserId: userId,
      })

      .then((res) => {
        // axios.post(environment.dap_url + "dapDevice/ReceiveDevice?deviceId="+e.target.value).then((resp)=>{
        MySwal.fire({
          title: <p>Successfully Received the Box</p>,
          type: "success",
        });
        // });
        getShipmentData(match.params.id);
      })
      .catch((err) => {
        MySwal.fire({
          title: <p>Failed to recieve the Box</p>,
          type: "error",
        });
      });
  };
  const getShipmentData = (id) => {
    axios
      .get(environment.dap_url + "shipmentApi/getByIdWithLogs?_id=" + id)
      .then((res) => {
        console.log("ankit");
        console.log(res.data.shipmentDetails[0].status);
        setIsReturn(res.data.shipmentDetails[0].isShipmentReturn);
        setStatus(res.data.shipmentDetails[0].status);
        setShipmentDetails(res.data.shipmentDetails[0]);
        setDeviceDetails(res.data.shipmentDetails[0].shipmenboxes);
        setShipmentLogs(res.data.shipmentLogs);
        setConsignorDetails(res.data.shipmentDetails[0].consignordetails[0]);
        setPartnerDetails(res.data.shipmentDetails[0].consigneedetails[0]);
        if (res.data.shipmentDetails[0].hasOwnProperty("logisticId")) {
          setcreatedbyManager(true);
        }
        axios
          .get(
            environment.dap_url +
              "users/" +
              res.data.shipmentDetails[0].consignordetails[0].createdBy
          )
          .then((res) => {
            setPartnerData(res.data);
            console.log(res.data);
          })
          .catch((err) => {
            console.log(err);
          });

        // if (res.data.shipmentDetails[0].status == 1) {
        //   button = <span class="label label-info">In Transition</span>;
        // }
        console.log(res.data);
      })
      .catch((err) => {});
  };
  console.log(shipmentDetails);
  const EnterDocket = () => {
    axios
      .post(
        environment.dap_url +
          "shipmentApi/addDocketNo?shipmentId=" +
          match.params.id,
        {
          docketNo: DocketNo,
        }
      )
      .then((res) => {
        console.log(res);
        console.log("ankit");
        setShow(false);
        getShipmentData(match.params.id);
        handleClose();
        window.location.reload();
      })
      .catch((err) => {});
  };
  const ViewDevices = () => {
    alert();
  };
  console.log(partnerdetails.tenantId);
  const ReceiveShipment = () => {
    axios
      .get(
        environment.dap_url +
          "shipmentApi/receiveShipment?shipmentId=" +
          match.params.id
      )
      .then((res) => {
        //back to inventory api

        MySwal.fire({
          title: <p>Successfully Received the Shipment</p>,
          type: "success",
        });
        setIsReceived(true);
        getShipmentData(match.params.id);
      })
      .catch((err) => {});
  };
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Docket No.</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Docket No.</Form.Label>
            <Form.Control
              type="text"
              //value={deviceData.accessToken}
              placeholder="Docket No."
              onChange={(e) => setDocketNo(e.target.value)}
            ></Form.Control>
            {/* <div>
              {Object.keys(nameErrors).map((key) => {
                return <div style={{ color: "red" }}>{nameErrors[key]}</div>;
              })}
            </div> */}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={EnterDocket} disabled={DocketNo.trim().length === 0 ? true : false}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showdevices} onHide={handleCloseDevices}>
        <Modal.Header closeButton>
          <Modal.Title>Box Assets</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Device Category</th>
                <th scope="col">Device Label</th>
                <th scope="col">Device Version</th>
              </tr>
            </thead>
            <tbody>
              {devices?.map((val, key) => {
                return (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{val.deviceType}</td>
                    <td>{val.deviceLabel}</td>
                    <td>{val.deviceVersion}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseDevices}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="container-fluid">
        <NavbarNew />
        <div class="col-md-12">
          {isReturn ? (
            <Link to="/myreturnshipments" className="btn btn-light mt-3">
              Go Back
            </Link>
          ) : (
            <Link to="/myshipments" className="btn btn-light mt-3">
              Go Back
            </Link>
          )}
          {status == 3 && isReturn == false ? (
            <Button
              variant="light"
              className="btn btn-light mt-3"
              onClick={handleShow}
            >
              Enter Docket No.
            </Button>
          ) : status == 1 ? (
            <>
              <Button
                variant="light"
                className="btn btn-light mt-3"
                onClick={Approve}
              >
                Approve
              </Button>
              <Button
                variant="light"
                className="btn btn-light mt-3"
                onClick={Reject}
              >
                Reject
              </Button>
            </>
          ) : isReturn == true && status == 5 ? (
            <Button
              variant="light"
              className="btn btn-light mt-3"
              onClick={ReceiveShipment}
            >
              Received Shipment
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="container-fluid">
        <h4 className="card-title">Shipment Details</h4>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th width="50%" scope="row">
                Country
              </th>
              <td>{shipmentDetails.consignmentCountry}</td>
            </tr>
            <tr>
              <th scope="row">State</th>
              <td>{shipmentDetails.consignmentState}</td>
            </tr>
            <tr>
              <th scope="row">City</th>
              <td>{shipmentDetails.consignmentCity}</td>
            </tr>
            <tr>
              <th scope="row">Phone</th>
              <td>{shipmentDetails.phone}</td>
            </tr>
            <tr>
              <th scope="row">Carton No.</th>
              <td>{shipmentDetails.cartonQr}</td>
            </tr>
            {shipmentDetails.docketNo && (
              <tr>
                <th scope="row">Docket No.</th>
                <td>{shipmentDetails.docketNo}</td>
              </tr>
            )}

            {shipmentDetails.isShipmentReturn == true ? (
              <tr>
                <th scope="row">Reason</th>
                <td>{shipmentDetails.Reason}</td>
              </tr>
            ) : (
              ""
            )}
            <tr>
              <th scope="row">Address</th>
              <td>{shipmentDetails.address}</td>
            </tr>
            <tr>
              <th scope="row">Status</th>
              <td>
                {/* {(() => {
                          switch (shipmentDetails.status) {
                            case 0:
                              return "Intialized";
                            case 1:
                              return "In transit";
                            case 2:
                              return "Received";
                            case 3:
                              return "Completed";
                            default:
                              return "#FFFFFF";
                          }
                        })()} */}
                {shipmentDetails.status == 0 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{ backgroundColor: "#6867AC" }}
                  >
                    Initalized
                  </button>
                ) : shipmentDetails.status == 1 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{ backgroundColor: "#6867AC" }}
                  >
                    Finalized
                  </button>
                ) : shipmentDetails.status == 5 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(230, 181, 102)",
                    }}
                  >
                    In - Transit
                  </button>
                ) : shipmentDetails.status == 3 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{ backgroundColor: "#6867AC" }}
                  >
                    Approved
                  </button>
                ) : shipmentDetails.status == 4 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "rgb(233, 6, 6)",
                      borderColor: "rgb(233, 6, 6)",
                    }}
                  >
                    Rejected
                  </button>
                ) : shipmentDetails.status == 6 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(233, 181, 102)",
                    }}
                  >
                    shipment received
                  </button>
                ) : shipmentDetails.status == 7 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(230, 181, 102)",
                    }}
                  >
                    All Boxes Received
                  </button>
                ) : shipmentDetails.status == 8 ? (
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    style={{
                      backgroundColor: "#E6B566",
                      borderColor: "rgb(230, 181, 102)",
                    }}
                  >
                    All device Installed
                  </button>
                ) : (
                  ""
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="container-fluid">
        <h4 className="card-title">Partner Details</h4>
        <table class="table table-bordered">
          <tbody>
            <tr>
              <th width="50%" scope="row">
                Name
              </th>
              <td>
                {isReturn
                  ? consignordetails.userFirstName + " " + consignordetails.userLastName
                  : partnerdetails.userFirstName + " " + partnerdetails.userLastName}
              </td>
            </tr>
            <tr>
              <th scope="row">Organisation</th>
              <td>
                {isReturn
                  ? consignordetails.organization
                  : partnerdetails.organization}
              </td>
            </tr>
            <tr>
              <th scope="row">Phone No.</th>
              <td>
                {isReturn ? consignordetails.phone : partnerdetails.phone}
              </td>
            </tr>
            <tr>
              <th scope="row">Email</th>
              <td>
                {isReturn ? consignordetails.email : partnerdetails.email}
              </td>
            </tr>
            <tr>
              <th scope="row">Address</th>
              <td>
                {isReturn ? consignordetails.address : partnerdetails.address}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* <div style={{ marginTop: "2%" }} className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <h4>Consignor Details</h4>
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <th width="50%" scope="row">
                        Name
                      </th>
                      <td>
                        {consignordetails.userFirstName +
                          " " +
                          consignordetails.userLastName}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Email</th>
                      <td>{consignordetails.email}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div style={{ marginTop: "2%" }} className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <h4>Boxes</h4>
                <Table striped>
                  <thead>
                    <tr>
                      <th id="bx">Box No.</th>
                      <th>Box Label</th>
                      <th>Box Type</th>
                      <th>Is Received</th>
                      <th>Info</th>
                    </tr>
                  </thead>
                  <tbody>
                    {devicedeials?.map((val, key) => {
                      return (
                        <tr key={key}>
                          <td>{key + 1}</td>
                          <td>{val.boxQr}</td>
                          <td>{val.boxType}</td>
                          {/* <td>{val.shipmentDevices}</td> */}
                          <td>
                            <Toggle
                              id="cheese-status"
                              checked={val.isBoxReceived}
                              value={val._id}
                              disabled={!(isReturn && status >= 6)}
                              // defaultChecked={this.state.cheeseIsReady}
                              onChange={(e) => toggle(e)}
                            />
                            <label htmlFor="cheese-status"></label>
                          </td>
                          <td>
                            <Button
                              variant="primary"
                              className="btn btn-sm"
                              onClick={(e) =>
                                handleShowDevices(key, val.shipmentDevices, e)
                              }
                            >
                              View
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShipmentDetailsPage;
